module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "usergroup-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'User Group',
          to: {
            path: '/user-group'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah User Group' :
            'Ubah User Group',
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah User Group" : "Ubah User Group") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Nama User Group\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Masukkan Nama User Group",
      "outlined": ""
    },
    model: {
      value: (_vm.form.user_group_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_group_name", $$v)
      },
      expression: "form.user_group_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pa-0"
  }, [_vm._v("\n                    Deskripsi\n                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi User Group",
      "outlined": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "Konten Spesifik",
      "outlined": ""
    },
    model: {
      value: (_vm.form.is_specific),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_specific", $$v)
      },
      expression: "form.is_specific"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.$route.query.id) ? _c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "text": ""
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-card', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Paket\n                                ")])], 1)], 1), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.packages,
      "headers": _vm.headerPackages,
      "has-custom-pagination": false,
      "custom-pagination-per-page": 5,
      "custom-pagination-total-items": _vm.packages.length,
      "custom-pagination-current-page": _vm.pageNumber
    },
    on: {
      "changePage": function($event) {
        _vm.pageNumber = $event
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.id) ? _c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "text": ""
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-card', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                                    Konten Spesifik\n                                ")])], 1)], 1), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.contens,
      "headers": _vm.headerContens,
      "has-custom-pagination": false,
      "custom-pagination-per-page": 5,
      "custom-pagination-total-items": _vm.contens.length,
      "custom-pagination-current-page": _vm.pageNumber
    },
    on: {
      "changePage": function($event) {
        _vm.pageNumber = $event
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        !_vm.$route.query.id ? _vm.saveData() : _vm.editData()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c062f21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/user_group/components/UserGroupForm.vue
// module id = 2143
// module chunks = 1